import { IMenuRequest } from '../types';
import { createFormData } from 'src/helpers';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from '../constants';

export const createMenu = async (payload: IMenuRequest) => {
  const requestBody = createFormData(payload);
  try {
    const res = await fetch(`${API_URL}/menus`, {
      method: 'POST',
      body: requestBody,
    });
    if (!res.ok) throw new Error(res.statusText);
    return res.json();
  } catch (e) {
    throw new Error('Could not create menu', { cause: e });
  }
};
